<input hidden type="file" accept=".xlsx" #fileDropRef id="fileDropRef" [accept]="accept"
  (change)="fileBrowseHandler($event.target.files)" />
<div class="d-flex align-items-center gap-1">
  <button type="button" class="mb-3 add-button" mat-flat-button color="primary" (click)="fileDropRef.click()">
    <span class="navigation-button">Upload portfolio</span>
  </button>
  <app-info-popover
    [company]="formatInfo"
    [title]="'Expected file format'"
    [portfolioCreateContent]="4"
  ></app-info-popover>
</div>